window.COFFEE_ETHIOPIA_REGIONS = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "id": "ETH-GUJI",
        "name": "Guji",
        "level": 3,
        "parent": "ETH",
        "summary": "Explore Guji, one of Ethiopia’s renowned coffee-producing regions.",
        "hasChildren": true,
        "osmRelation": "13422221"
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [[
          [38.4246001,6.3668478],
          [38.4284944,6.3872366],
          [38.4418866,6.4066527],
          [38.4541414,6.4180579],
          [38.4633867,6.4236527],
          [38.4713672,6.4286663],
          [38.4761368,6.4316627],
          [38.5046469,6.4376327],
          [38.5165967,6.4378047],
          [38.538432,6.4380826],
          [38.5610522,6.4408643],
          [38.5673972,6.4417426],
          [38.5841672,6.4383025],
          [38.6071701,6.4241241],
          [38.6275974,6.4183225],
          [38.6458698,6.4244668],
          [38.65558,6.4226546],
          [38.6623075,6.4203724],
          [38.6728676,6.4102724],
          [38.6914777,6.4075123],
          [38.6967677,6.4024623],
          [38.7034295,6.3972987],
          [38.7080177,6.3937423],
          [38.7183578,6.3983223],
          [38.7395079,6.4102423],
          [38.7508756,6.4108122],
          [38.7588129,6.4103572],
          [38.767338,6.4044922],
          [38.772348,6.4010522],
          [38.784288,6.3893422],
          [38.7963783,6.3738127],
          [38.8129881,6.3572121],
          [38.832883,6.3445111],
          [38.8533982,6.321632],
          [38.86407,6.3119844],
          [38.8749683,6.302132],
          [38.8864383,6.286072],
          [38.8985983,6.2599119],
          [38.9045016,6.252259],
          [38.9217783,6.2298619],
          [38.9263383,6.2216119],
          [38.9298543,6.2152462],
          [38.9373684,6.2016418],
          [38.9430784,6.1932218],
          [38.9509084,6.1816818],
          [38.9614584,6.1605818],
          [38.9889885,6.1484117],
          [39.0121786,6.1435817],
          [39.0353487,6.1387516],
          [39.045896,6.1429795],
          [39.0564788,6.1472216],
          [39.0805789,6.1543116],
          [39.103759,6.1586515],
          [39.1327237,6.160097],
          [39.131281,6.1673065],
          [39.1140708,6.1778661],
          [39.1044607,6.203555],
          [39.1005707,6.2198343],
          [39.0948506,6.2351936],
          [39.0868305,6.2533128],
          [39.0917137,6.2721034],
          [39.1103092,6.2886316],
          [39.1204099,6.3002925],
          [39.1266113,6.3231896],
          [39.1277753,6.3373648],
          [39.157444,6.3318319],
          [39.1802646,6.3154182],
          [39.199525,6.3015494],
          [39.2184655,6.2921402],
          [39.2275157,6.2876406],
          [39.2598464,6.2659124],
          [39.289557,6.224406],
          [39.3208877,6.1838095],
          [39.3338279,6.144673],
          [39.3332896,6.120367],
          [39.3471912,6.1094455],
          [39.3560758,6.0967546],
          [39.3484604,6.087871],
          [39.343495,6.0796765],
          [39.348388,6.0514913],
          [39.3700476,6.0216884],
          [39.3694025,6.0117257],
          [39.3763833,6.0066493],
          [39.3763832,5.9939584],
          [39.3814601,5.9850748],
          [39.3816973,5.9792076],
          [39.3827293,5.9698458],
          [39.3941524,5.9558858],
          [39.4081139,5.9444639],
          [39.4093831,5.930504],
          [39.4246138,5.9266967],
          [39.4347677,5.9089294],
          [39.4471676,5.8975076],
          [39.4528702,5.8980049],
          [39.4578189,5.8960257],
          [39.4637574,5.8965205],
          [39.4687061,5.8910775],
          [39.4696958,5.881676],
          [39.4657368,5.8742537],
          [39.4605407,5.8717797],
          [39.4588086,5.8648523],
          [39.453365,5.8603989],
          [39.4503957,5.8514923],
          [39.4484162,5.8445648],
          [39.4513854,5.8381322],
          [39.4553444,5.83071],
          [39.4523751,5.8220507],
          [39.4578187,5.8193292],
          [39.4617777,5.8153707],
          [39.4624539,5.8076256],
          [39.4580661,5.799784],
          [39.4544555,5.7945003],
          [39.4562798,5.7885544],
          [39.46498,5.7756656],
          [39.4777503,5.7567572],
          [39.4976645,5.7319473],
          [39.5019808,5.7265698],
          [39.5241613,5.7032818],
          [39.5477919,5.6997621],
          [39.5859429,5.7116009],
          [39.6006232,5.7156005],
          [39.6151236,5.7195501],
          [39.6490844,5.7166802],
          [39.6848153,5.6986418],
          [39.7044657,5.6765137],
          [39.7155959,5.6466063],
                    [39.7031055,5.6206787],
          [39.6784348,5.5881217],
          [39.6650043,5.5539248],
          [39.6673727,5.5491724],
          [39.6825547,5.5187079],
          [39.7036252,5.5101486],
          [39.7382761,5.5123383],
          [39.774987,5.5170577],
          [39.7831,5.51703],
          [39.7893,5.51701],
          [39.8015976,5.5169677],
          [39.8416986,5.5071984],
          [39.8712193,5.4917097],
          [39.8970399,5.4679718],
          [39.9148102,5.4355246],
          [39.9429008,5.4051172],
          [39.9800017,5.3971878],
          [40.0100425,5.4012274],
          [40.0345631,5.3981676],
          [40.0158778,5.3753126],
          [39.9935396,5.3479885],
          [39.9899,5.34348],
          [39.9431705,5.2863779],
          [39.9081794,5.2210038],
          [39.8792785,5.141721],
          [39.8595935,5.0944803],
          [39.8344671,5.0341807],
          [39.8137365,5.0034835],
          [39.8053261,4.9528981],
          [39.7848654,4.8920136],
          [39.7722896,4.8629437],
          [39.7659448,4.8482775],
          [39.7593846,4.8025016],
          [39.744434,4.7249186],
          [39.7186533,4.6950413],
          [39.707413,4.6826424],
          [39.6924926,4.6668039],
          [39.6625,4.65695],
          [39.6393,4.66437],
          [39.6187,4.67884],
          [39.5949102,4.6830027],
          [39.5747697,4.6995813],
          [39.5468291,4.7101804],
          [39.5360688,4.71525],
          [39.5241585,4.7210095],
          [39.4965528,4.727344],
          [39.4675471,4.7252093],
          [39.4349963,4.7250094],
          [39.4093,4.73998],
          [39.4029,4.74558],
          [39.3976,4.75016],
          [39.3857552,4.7604663],
          [39.3692748,4.7777248],
          [39.3640447,4.8039425],
          [39.3620147,4.8287803],
          [39.3519545,4.8492585],
          [39.3247,4.86562],
          [39.299,4.87117],
          [39.272,4.86866],
          [39.2455819,4.8739766],
          [39.2160112,4.8864256],
          [39.1905706,4.904394],
          [39.1720202,4.927872],
          [39.1641334,4.9375392],
          [39.1615284,4.9426738],
          [39.1479797,4.9573394],
          [39.1331,4.98427],
          [39.1239,4.99809],
          [39.1198,5.00706],
          [39.1088,5.02777],
          [39.1057289,5.0462516],
          [39.0856984,5.0462017],
          [39.0785882,5.0475916],
          [39.0647079,5.0535911],
          [39.0524376,5.0602705],
          [39.0428181,5.0672304],
          [39.0279,5.07802],
          [39.01,5.10519],
          [38.9951825,5.128063],
          [38.9672,5.13859],
          [38.9326,5.12628],
          [38.9085741,5.1091966],
          [38.9035071,5.1145457],
          [38.8987715,5.1224983],
          [38.8906772,5.1269304],
          [38.8885572,5.1346384],
          [38.8839,5.14119],
          [38.8801,5.14659],
          [38.8758,5.15333],
          [38.8711494,5.156423],
          [38.8666833,5.1612311],
          [38.8633,5.16778],
          [38.8556018,5.1635436],
          [38.8454992,5.1673233],
          [38.840795,5.1695992],
          [38.8388321,5.1748431],
          [38.8411,5.18089],
          [38.8419,5.18949],
          [38.8342097,5.1974589],
          [38.829,5.21335],
                    [38.8311224,5.2218168],
          [38.8257,5.2414],
          [38.8213323,5.2814415],
          [38.8058,5.2926],
          [38.7901316,5.3021897],
          [38.7757443,5.3108229],
          [38.7713412,5.3316772],
          [38.7589,5.3474],
          [38.7486071,5.3649281],
          [38.7338,5.3851],
          [38.7153900,5.4056408],
          [38.7139,5.4286],
          [38.7118,5.4537],
          [38.7152902,5.4806941],
          [38.7216,5.5029],
          [38.7288,5.5254],
          [38.7390910,5.5511078],
          [38.7274,5.5716],
          [38.7170657,5.5998206],
          [38.6967,5.6131],
          [38.6778,5.6265],
          [38.6599010,5.6382152],
          [38.6368,5.6387],
          [38.6139,5.6371],
          [38.5921794,5.6425796],
          [38.5608829,5.6317891],
          [38.5351,5.6311],
          [38.5101611,5.6307102],
          [38.4928,5.6459],
          [38.4754,5.6597],
          [38.4691521,5.6684775],
          [38.4497268,5.6922170],
          [38.4259,5.7048],
          [38.4014,5.7116],
          [38.3774213,5.7181148],
          [38.3558,5.7352],
          [38.3396,5.7471],
          [38.3266995,5.7558821],
          [38.3196,5.7824],
          [38.3148286,5.8087563],
          [38.3137495,5.8432864],
          [38.3089,5.8686],
          [38.3027,5.8941],
          [38.2968,5.9203],
          [38.2907,5.9468],
          [38.2849,5.9741],
          [38.2768141,5.9990522],
          [38.2798581,6.0076063],
          [38.2863789,6.0117421],
          [38.2996298,6.0204158],
          [38.3147266,6.0291573],
          [38.3207155,6.0487427],
          [38.3234114,6.0531486],
          [38.3289072,6.0621177],
          [38.3340498,6.0704921],
          [38.3378756,6.0761327],
          [38.3523526,6.0975484],
          [38.3558181,6.1050716],
          [38.3633594,6.1215104],
          [38.3661305,6.1441135],
          [38.3950660,6.1830827],
                    [38.4016907,6.1904326],
          [38.4068904,6.2073482],
          [38.4112841,6.2249573],
          [38.4165828,6.2454126],
          [38.4202374,6.2658293],
          [38.4225189,6.2861928],
          [38.4257808,6.3079120],
          [38.4243908,6.3269612],
          [38.4226238,6.3495214],
          [38.4233414,6.3559527],
          [38.4246001,6.3668478]
        ]]
      }
    }
  ]
};

